<div class="content">

    <div class="tlr-bluetag-container">

        <div class="section-title">Find TLR's Given Blue Tag Number Report
        </div>
        <div class="partioned-table">
            <div class="row">
                <div class="cell label label-text">Enter Blue Tag Number
                </div>
                <div class="cell value AreaBlue p-1-0 m-left">
                    <input name="maximo order" type="text" id="contentContent_txtBlueTag" (keydown.enter)="searchTag()"  [(ngModel)]="blueTagNumber"  class="inputArea">
                    @if(fillMendatoryFeild){<span> Please enter Blue Tag Number   </span>}
                    <button class="search-btn" (click)="searchTag()" >Search Tag</button> 
                    @if(showError){<b style="color: red;"> No Data Found.</b>}
                </div>

            </div>

        </div>

    </div>

    <div *ngIf="showTable" class="table-chart-container mt-10">
        <div class="exportToExcel excel-btn">
            <div class="actions">
                <button pButton type="button" label="Export To Excel" icon="pi pi-file-excel" class="p-button-outlined"
                    (click)="exportToExcel()">Export To Excel</button>
            </div>
        </div>

        <p-table [value]="airComplianceDetails" [paginator]="true" [rows]="10" id="StyleTable"
            styleClass="p-datatable-gridlines">
            <ng-template pTemplate="header">
                <tr>
                    <th>Tag Number</th>
                    <th>Data Entry Date</th>
                    <th>Oper User ID</th>
                    <th>Division</th>
                    <th>Section</th>
                    <th>Plant</th>
                    <th>LDAR</th>
                    <th>Op. PSI</th>
                    <th>Op. Temp</th>
                    <th>Op. Comments</th>
                    <th>Insp. User ID</th>
                    <th>Service Class</th>
                    <th>OA User ID</th>
                    <th>Permanent Repair Date</th>
                    <th>TLR Surveillance</th>
                    <th>Eng. User ID</th>
                    <th>TLR Type</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-detail>
                <tr>
                    <td><a routerLink="/details-section/{{detail.tag_number}}">
                            {{ detail.tag_number }}</a></td>
                    <td>{{detail.de_date_entered | date:'MM/dd/yyyy'}}</td>
                    <td>{{detail.de_cai}}</td>
                    <td>{{detail.division_name}}</td>
                    <td>{{detail.section_name}}</td>
                    <td>{{detail.plant_name}}</td>
                    <td>{{detail.rule_1173}}</td>
                    <td>{{detail.operating_PSI}}</td>
                    <td>{{detail.operating_temperature}}</td>
                    <td>{{detail.OperatorComments}}</td>
                    <td>{{detail.InspectionCAI}}</td>
                    <td>{{detail.ServiceClass}}</td>
                    <td>{{detail.OACAI}}</td>
                    <td [ngClass]="commonService.getDateColorClass(detail.permanent_repair_date)">{{detail.permanent_repair_date | date:'MM/dd/yyyy'}}</td>
                    <td>{{detail.TLRSurveillance}}</td>
                    <td>{{detail.EngineeringCAI}}</td>
                    <td>{{detail.TLRtype}}</td>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="17">No records found.</td>
                </tr>
            </ng-template> -->
        </p-table>


    </div>

</div>